import { SHORTER_SUF_FLAG_KEY } from "../constants/ab-tests";

/**
 * At hydration time, if a user has started the signup flow but has no
 * stored shorter-suf variant, they started before the test went live. Pin them to control
 * so they finish the flow they started instead of being bucketed into the test mid-flow.
 */
export function pinShorterSufControlForInProgressUsers<
  T extends {
    featureFlags: Record<string, string | boolean>;
    cats: Record<string, unknown>;
  },
>(data: T): T {
  const hasStoredVariant = SHORTER_SUF_FLAG_KEY in data.featureFlags;
  const hasStartedSignup = Object.keys(data.cats).length > 0;

  if (!hasStoredVariant && hasStartedSignup) {
    data.featureFlags = { ...data.featureFlags, [SHORTER_SUF_FLAG_KEY]: "control" };
  }

  return data;
}
